export const unreportedStatsigInitialisationErrorState: {
	set: (error: Error) => void;
} = {
	set: () => undefined,
};
